<template>
    <div class="modal-wrapper" v-if="show">
        <div class="scroll" ref="scrollWrapper" @click.self="closeModal">
            <div class="news-modal">
                <div class="news-modal-header">
                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.0054 10.5039L11.5069 13.0054L10.0062 11.5048" stroke="#00614D" stroke-width="1.1"
                            stroke-linecap="round" stroke-linejoin="round" />
                        <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M12.005 4.00166C7.0329 4.00166 3.00122 7.36174 3.00122 11.5019C3.07638 14.0002 4.45423 16.2768 6.63273 17.5021C6.41634 18.0901 6.11543 18.6435 5.7395 19.1448C5.53201 19.4478 5.53714 19.8484 5.75233 20.1459C5.96751 20.4435 6.34638 20.5738 6.69906 20.4716C7.90189 20.1214 9.03405 19.5631 10.0442 18.8221C10.6907 18.9433 11.3472 19.0036 12.005 19.0021C16.977 19.0021 21.0087 15.642 21.0087 11.5019C21.0087 7.36175 16.977 4.00166 12.005 4.00166Z"
                            stroke="#00614D" stroke-width="1.1" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    Новостная лента
                </div>
                <div class="news-modal-body" v-if="data">
                    <div class="news-modal-title">{{ data.title }}</div>
                    <!-- <div class="news-modal-image" :style="{ backgroundImage: `url(${data.image})` }"></div> -->
                    <img class="news-modal-image" :src="data.image" alt="">
                    <div class="news-modal-subtitle">{{ data.text }}</div>
                    <div class="news-modal-footer">
                        <div class="news-modal-footer__item likes" :class="isLiked(data) ? 'active' : ''"
                            @click="reactionHandler(data, 1, 'news')">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M15.7 4C18.87 4 21 6.98 21 9.76C21 15.39 12.16 20 12 20C11.84 20 3 15.39 3 9.76C3 6.98 5.13 4 8.3 4C10.12 4 11.31 4.91 12 5.71C12.69 4.91 13.88 4 15.7 4Z"
                                    stroke="currentColor" stroke-width="1.1" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                            <span v-if="data.reactions_count != 0">
                                {{ data.reactions_count }}
                            </span>
                        </div>
                        <div class="news-modal-footer__item comments">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M15 8.5H9" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M6 3H18C19.6568 3 21 4.34315 21 6V15C21 16.6568 19.6568 18 18 18H7.5L3.80841 20.8926C3.65785 21.0106 3.45317 21.0324 3.28117 20.9486C3.10918 20.8649 3.00002 20.6904 3 20.4991V6C3 4.34315 4.34315 3 6 3Z"
                                    stroke="currentColor" stroke-width="1.1" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M12 12.5H9" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                            <span v-if="data.comments_count != 0">
                                {{ data.comments_count }}
                            </span>
                        </div>
                        <div class="news-modal-footer__item date">{{ timeAgoSimple(data.created_at) }}</div>
                    </div>
                </div>
                <div class="news-modal-comments">
                    <div v-if="!commentsLoading && comments" class="news-modal-comments-list">
                        <div class="news-modal-comments-item" v-for="comment in comments" :key="comment.id">
                            <div class="news-modal-comments-item__main">
                                {{ comment.author.full_name }}
                                <div class="news-modal-comments-item__date">
                                    {{ timeAgoSimple(comment.created_at) }}
                                    <i v-if="comment.is_edited">( изм. )</i>
                                </div>
                            </div>
                            <div v-if="comment.is_my" class="news-modal-comments-item-utils">
                                <span class="news-modal-comments-item-utils__delete" @click="deleteComment(comment.id)">Удалить</span>
                                <span class="news-modal-comments-item-utils__edit" @click="editCommentHandler(comment)">Редактировать</span>
                            </div>
                            <div class="news-modal-comments-item-text">
                                    {{ comment.text }}
                                <span
                                    class="news-modal-comments-item-text__like"
                                    :class="isLiked(comment) ? 'active' : ''"
                                    @click="reactionHandler(comment, 1, 'comment')"
                                >
                                    
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd"
                                            d="M15.7 4C18.87 4 21 6.98 21 9.76C21 15.39 12.16 20 12 20C11.84 20 3 15.39 3 9.76C3 6.98 5.13 4 8.3 4C10.12 4 11.31 4.91 12 5.71C12.69 4.91 13.88 4 15.7 4Z"
                                            stroke="currentColor" stroke-width="1.1" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span v-if="comment.reactions_count != 0">{{ comment.reactions_count }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="news-modal-comments-input">
                        <div class="input-wrapper">
                            <div v-if="editComment" class="news-modal-comments-input__edit">
                                <span>Редактирование</span>
                                {{ editComment.text }}
                                <div class="close" @click="editCommentCancel">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.63574 2.63618L15.3637 15.3641" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/>
                                        <path d="M2.63599 15.3639L15.3639 2.63601" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/>
                                    </svg>
                                </div>
                            </div>
                            <textarea v-model="newComment" class="textarea" name="comment" id="comment"
                                placeholder="Добавить комментарий" @keydown.enter="onTextareaEnter" ref="commentInput">\
                            </textarea>
                        </div>

                        <button class="btn" @click="addComment">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M5.32312 19.878L19.7521 13.179C20.7501 12.716 20.7501 11.282 19.7521 10.819L5.32312 4.12199C4.28812 3.64199 3.19312 4.65999 3.58012 5.74299L5.81312 11.997L3.58012 18.258C3.19312 19.34 4.28812 20.358 5.32312 19.878Z"
                                    stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M5.81006 12H20.5001" stroke="currentColor" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import apiClient from '@/api/index'
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            show: false,
            data: null,
            commentsLoading: true,
            comments: null,
            newComment: '',
            editComment: null
        }
    },

    methods: {
        ...mapActions({
            setReaction: 'news/setReaction',
            delReaction: 'news/delReaction'
        }),

        showModal(id) {
            this.fetchNew(id)
            this.show = true
            this.fetchComments(id, false)
        },

        isLiked(item) {
            if (item.user_reactions.length) {
                const reaction = item.user_reactions.find(x => x.reaction_type == 1)
                if (reaction) {
                    return reaction
                } else {
                    return false
                }
            } else {
                return false
            }
        },

        onTextareaEnter(event) {
            // защита от лишних вызовов: срабатываем только на реальном Enter
            if (event.key !== 'Enter') return;

            if (event.shiftKey) {
                // Shift+Enter — разрешаем вставить перенос строки
                return;
            }

            // обычный Enter — предотвращаем вставку новой строки и всплытие
            event.preventDefault();
            event.stopPropagation();
            this.addComment();
        },

        reactionHandler(item, reaction, type) {
            const isLiked = this.isLiked(item)
            if (isLiked) {
                this.delReaction(isLiked.id)
                .then(() => {
                    if(type == 'news') {
                        this.fetchNew(this.data.id)
                    } else {
                        this.fetchComments(this.data.id, true)
                    }
                })
            } else {
                this.setReaction({ id: item.id, reaction: reaction, type: type })
                .then(() => {
                    if(type == 'news') {
                        this.fetchNew(this.data.id)
                    } else {
                        this.fetchComments(this.data.id, true)
                    }
                })
            }
        },

        fetchNew(id) {
            apiClient.get(`/projects/tcode/news/${id}`, {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.data = response.data
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        fetchComments(id, current) {
            if(!current) {
                this.commentsLoading = true
            }
            apiClient.get(`/projects/tcode/comments?news=${id}`, {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.comments = response.data.results
                    }

                    this.commentsLoading = false
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        addComment() {
            if (!this.newComment.length)
                return

            if(!this.editComment) {
                this.sendNewComment(this.data.id, this.newComment)
                .then((result) => {
                    if (result.status == 201) {
                        this.newComment = ''
                        this.fetchNew(this.data.id)
                        this.fetchComments(this.data.id, true)
                    } else {
                        alert('Ошибка!')
                    }

                })
            } else {
                this.sendEditedComment()
                .then((result) => {
                    if(result.status == 200) {
                        this.newComment = ''
                        this.editComment = null
                        this.fetchComments(this.data.id, true)
                    }
                })
            }
            
        },

        async sendNewComment(id, comment) {
            return await apiClient.post(`/projects/tcode/comments/`,
                    {
                        news: id,
                        text: comment
                    },
                    {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        deleteComment(id) {
            apiClient.delete(`/projects/tcode/comments/${id}/`,
                {
                    headers: {
                        Authorization: 'Token ' + localStorage.getItem('token')
                    }
                })
            .then((response) => {
                if(response.status == 204) {
                    this.fetchComments(this.data.id, true)
                    this.fetchNew(this.data.id)
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },

        editCommentHandler(comment) {
            this.newComment = comment.text
            this.editComment = comment
            this.$refs.commentInput.focus()
        },

        editCommentCancel() {
            this.newComment = '',
            this.editComment = null
        },

        async sendEditedComment() {
            return apiClient
                .patch(`/projects/tcode/comments/${this.editComment.id}/`,
                    {
                        text: this.newComment
                    },
                    {
                        headers: {
                            Authorization: 'Token ' + localStorage.getItem('token')
                        }
                    })
                .then((response) => {
                    return response
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        timeAgoSimple(dateString) {
            const date = new Date(dateString);
            const now = new Date();
            const seconds = Math.floor((now - date) / 1000);

            if (seconds < 60) return 'только что';

            const minutes = Math.floor(seconds / 60);
            if (minutes < 60) return `${minutes} мин. назад`;

            const hours = Math.floor(seconds / 3600);
            if (hours < 24) return `${hours} ч. назад`;

            const days = Math.floor(seconds / 86400);
            if (days < 7) return `${days} д. назад`;

            const weeks = Math.floor(days / 7);
            if (weeks < 4) return `${weeks} нед. назад`;

            const months = Math.floor(days / 30);
            if (months < 12) return `${months} мес. назад`;

            const years = Math.floor(days / 365);
            return `${years} г. назад`;
        },

        closeModal(event) {
            // клик должен быть прямо по текущему элементу (фон), а не по вложенным элементам
            if (event && event.target !== event.currentTarget) return;
            this.show = false;
        }
    }
}
</script>
<style scoped lang="sass">
.modal-wrapper
    & .scroll
        position: fixed
        top: 0
        left: 0
        padding: 5dvh
        display: flex
        align-items: flex-start
        justify-content: center
        max-height: 100dvh
        width: 100%
        overflow-y: auto 
        @media only screen and (max-width: 425px)
            padding: 24px
.news-modal
    display: flex
    flex-direction: column
    width: 630px
    height: 100%
    font-size: 14px
    line-height: 100%
    background: var(--color-white)
    border-radius: 5px
    box-shadow: 0px 0px 10px 0px #00000014
    &-header 
        padding: 0 16px
        display: flex
        align-items: center
        gap: 6px
        min-height: 50px
        max-height: 50px
        font-weight: 700
        background: var(--color-light-blue)
        border-top-left-radius: 5px
        border-top-right-radius: 5px
    
    &-body 
        padding: 16px 20px
        display: flex
        flex-direction: column
        gap: 6px
        height: 100%
    &-title 
        margin-bottom: 12px
        font-weight: 700
        font-size: 18px
        line-height: 24px
    &-image 
        width: 100%
        border-radius: 5px

    &-subtitle 
        margin-top: 12px
        line-height: 20px
        white-space: pre-wrap
    
    &-footer
        margin-top: auto
        display: flex
        align-items: center
        gap: 12px
        color: var(--color-text-ligth)
        &__item 
            display: flex
            align-items: center
            gap: 4px
            &.likes
                cursor: pointer
                &:hover
                    color: var(--color-red) 
                &.active svg
                    color: var(--color-red)
                    fill: var(--color-red)
            &.date
                margin-left: auto
                cursor: default
    &-comments
        margin: 0 14px 0 20px
        padding: 16px 0 0 0
        &-list
            padding-right: 6px
        &-item
            padding: 18px 0
            display: grid
            grid-template-columns: repeat(2, 1fr)
            grid-gap: 12px
            border-bottom: 1px solid #D8D8D8
            &:first-child
                border-top: 1px solid #D8D8D8
            &__main
                display: flex
                align-items: center
                gap: 12px
                font-weight: 700
                color: var(--color-blue)
                @media only screen and (max-width: 425px)
                    grid-column: 1/ -1
                    justify-content: space-between
            &-utils 
                margin-left: auto
                display: flex
                align-items: center
                gap: 8px
                color: var(--color-text-ligth)
                @media only screen and (max-width: 425px)
                    margin-left: 0
                    grid-column: 1 / -1
                    grid-row: 3 / 4
                    justify-content: space-between
                &__delete
                    cursor: pointer
                    &:hover
                        color: var(--color-red)
                &__edit
                    cursor: pointer
                    &:hover
                        color: var(--color-blue)
            &-text
                grid-column: 1 / -1
                display: flex
                align-items: flex-start
                justify-content: space-between
                width: 100%
                white-space: pre-wrap
                word-wrap: break-word
                &__like
                    display: flex
                    align-items: center
                    gap: 4px
                    color: var(--color-text-ligth)
                    cursor: pointer
                    &:hover
                        color: var(--color-red) 
                    &.active svg
                        color: var(--color-red)
                        fill: var(--color-red)
            &__date
                font-weight: 500
                color: var(--color-text-ligth)
        &-input
            padding: 20px 0
            display: flex
            align-items: center
            gap: 12px
            & .input-wrapper 
                display: flex
                flex-direction: column
                gap: 8px
                width: 100%
                & .textarea
                    width: 100%
                    background: var(--color-light-beige)
            &__edit
                position: relative
                padding: 8px
                display: flex
                flex-direction: column
                gap: 8px
                background: #FCE1D8
                border-left: 2px solid var(--color-blue)
                white-space: pre-wrap
                word-wrap: break-word
                & span
                    color: var(--color-blue)
                & .close 
                    position: absolute
                    top: 8px
                    right: 8px
                    color: var(--color-blue)
                    & svg 
                        width: 12px
                        height: 12px
            & .btn 
                padding: 0 8px
                width: 40px
                color: var(--color-text-ligth)
                background: none
                &:hover 
                    color: var(--color-white)
                    
</style>